// @flow

const initSortSelections = (win: WindowProxy) => {
    var sortOrderElements = win.document.querySelectorAll('.view-menu__item--sort-option');

    for (var i = 0; i < sortOrderElements.length; ++i) {
        sortOrderElements[i].addEventListener('click', changeSort(win,sortOrderElements[i]));
    }
};


const changeSort = (win: WindowProxy, sortOrderElement: HTMLElement) => () => {
      win.location.href = sortOrderElement.dataset.sortUrl;
};

export default initSortSelections;